import {put, select} from "typed-redux-saga";
import {navigateTo, setRedirectUri, userLoginFailed} from "modules/actions";
import {getRedirectUri} from "modules/selectors";

// Move the user to a redirectUri, if there is no redirectUri,
// the user will be transferred to "/". Clear the redirectUri
export const navigateToRedirectUriSaga = function* () {
	try {
		const redirectUri = yield* select(getRedirectUri);

		if (redirectUri) {
			yield* put(navigateTo(redirectUri));
		} else {
			yield* put(navigateTo("/"));
		}

		yield* put(setRedirectUri(""));
	} catch (err) {
		const {message} = err as Error;
		yield* put(userLoginFailed({form: message}));
	}
};
